
























































































































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { hotTableColumns } from '../config/colums'
import {
  getHotList,
  createHotItem,
  changePublishStatus,
  deleteHotItem,
  changeItemPosition,
  getTargetUserList,
  editHotItem
} from '../../../service/search'
import { addWatermarker } from '../../../utils/renderWatermarker'
import { USER_NAME } from '../../../service/constant'
@Component
export default class Hot extends Vue {
  private searchContent: string = ''
  private searchType: string = 'PLATFORM'
  private searchStatus: string = ''
  public searchTargetUsers: any = [] // 搜索目标用户
  public targetUserList: any = [] // 目标用户集合

  public target_users_modal: any = [] // 弹窗内目标用户
  public modalType: string = '' //弹窗状态
  public content_id: string = '' //弹窗内id

  contentType = ''
  private types = [
    {
      value: 'PLATFORM',
      label: '平台'
    },
    {
      value: 'IDIOM',
      label: '成语'
    },
    {
      value: 'DUBBING',
      label: '趣味配音'
    },
    {
      value: 'PIC_BOOK',
      label: '绘本'
    },
    {
      value: 'LEVEL_READING',
      label: '分级阅读'
    },
    {
      value: 'LIGHT_COURSE',
      label: '轻课'
    },
    {
      value: 'CONTENT_COMPOSITION',
      label: '范文素材'
    }
  ]
  get userName() {
    return this.$store.state[USER_NAME]
  }
  async mounted() {
    // this.renderWaterMarker()
    this.renderTargetUserList()
    this.renderList(1)
    this.renderWaterMarker()
  }
  renderWaterMarker() {
    const document: any = window.document
    addWatermarker(document.querySelector('.hot-content'), `17题库 ${this.userName}`)
  }
  public hotTableColumns: any[] = hotTableColumns
  public isModalVisibale: boolean = false
  public confirmLoading: boolean = false
  public dataSource: any[] = []
  public content: string = ''
  public pagination = {
    current: 1,
    pageSize: 20,
    total: 0,
    showTotal: (total) => `共 ${total} 条`
  }
  get sumOfPages() {
    const { pageSize, total } = this.pagination
    return Math.ceil(total / pageSize)
  }
  get numberOfLastPage() {
    const { pageSize, total } = this.pagination
    return total % pageSize
  }

  // 根据id匹配目标用户
  get_target_users(data) {
    var arr: any[] = []
    var targrtUsersArr: any[] = []

    if (data.length > 0) {
      for (var i = 0; i < data.length; i++) {
        arr = arr.concat(data[i].id_list)
      }
    }
    if (this.targetUserList.length > 0) {
      arr.map((item, i) => {
        for (var j = 0; j < this.targetUserList.length; j++) {
          if (item == this.targetUserList[j].id) {
            targrtUsersArr.push(this.targetUserList[j].name)
          }
        }
      })
    }

    return targrtUsersArr.join(',')
  }
  async renderList(page) {
    const options = {
      content: this.searchContent,
      content_type: this.searchType,
      target_users: JSON.stringify(this.searchTargetUsers),
      status: this.searchStatus,
      page,
      page_size: this.pagination.pageSize
    }
    const { list, total } = await getHotList(options)
    this.dataSource = list

    this.pagination.total = total
    this.pagination.current = page
  }
  async renderTargetUserList() {
    const res = await getTargetUserList()
    this.targetUserList = res.data
  }
  handleTableChange(pagination) {
    this.renderList(pagination.current)
  }
  showModal(e) {
    this.modalType = 'add'
    this.isModalVisibale = true
    this.contentType = ''
    this.target_users_modal = []
  }
  async handleModalOk(e) {
    this.confirmLoading = true
    var target_users_modal_arr: any[] = []

    this.target_users_modal.map((item, i) => {
      for (var j = 0; j < this.targetUserList.length; j++) {
        if (item == this.targetUserList[j].id) {
          target_users_modal_arr.push(this.targetUserList[j])
        }
      }
    })
    if (this.modalType == 'add') {
      const options = {
        content: this.content,
        content_type: this.contentType,
        target_users: target_users_modal_arr
      }
      const { success, msg: message } = await createHotItem(options)
      if (success) {
        this.$message.success(message)
        this.confirmLoading = false
        this.isModalVisibale = false
        this.content = ''
        this.renderList(1)
      } else {
        this.confirmLoading = false
      }
    } else if (this.modalType == 'edit') {
      const options = {
        content: this.content,
        content_type: this.contentType,
        target_users: target_users_modal_arr,
        id: this.content_id
      }
      const { success, msg: message } = await editHotItem(options)
      if (success) {
        this.$message.success(message)
        this.confirmLoading = false
        this.isModalVisibale = false
        this.content = ''
        this.renderList(1)
      } else {
        this.confirmLoading = false
      }

      this.contentType = ''
      this.target_users_modal = []
    }
  }
  handleModalCancel(e) {
    this.isModalVisibale = false
    this.content = ''
  }
  async handleChangeStatus(record: any, action: number) {
    const options = {
      content_id: record.id,
      action
    }
    const { success, msg: message } = await changePublishStatus(options)
    if (success) {
      this.$message.success(message)
      // const newData = [...this.dataSource]
      // newData.forEach((item) => {
      //   item.status = item.key === record.key ? action : item.status
      // })
      // this.dataSource = newData
      this.renderList(this.pagination.current)
    } else {
      this.$message.error(message)
    }
  }
  async handleDeleteItem(record) {
    const options = {
      content_id: record.id
    }
    const { success, msg: message } = await deleteHotItem(options)
    if (success) {
      this.$message.success(message)
      const newData = [...this.dataSource]
      newData.splice(record.key, 1)
      this.dataSource = newData
      let page = 0
      if (newData.length) {
        page = this.pagination.current
      } else {
        page = this.pagination.current === 1 ? 1 : this.pagination.current - 1
      }
      this.renderList(page)
    } else {
      this.$message.error(message)
    }
  }
  async handleChangeItemPosition(record, action) {
    const options = {
      content_type: record.content_type,
      content_id: record.id,
      action,
      content: this.searchContent,
      status: this.searchStatus
    }
    const { success, msg: message } = await changeItemPosition(options)
    if (success) {
      this.$message.success(message)
      this.renderList(this.pagination.current)
    } else {
      this.$message.error(message)
    }
  }
  searchHotList() {
    this.renderList(1)
  }
  handleEditItem(record) {
    this.target_users_modal = []
    var arr: any[] = []

    this.isModalVisibale = true
    this.content = record.content
    this.contentType = record.content_type
    this.content_id = record.id
    var target_users_list = record.target_users

    if (target_users_list.length > 0) {
      for (var i = 0; i < target_users_list.length; i++) {
        arr = arr.concat(target_users_list[i].id_list)
      }
    }
    for (let j = 0; j < arr.length; j++) {
      for (let i = 0; i < this.targetUserList.length; i++) {
        if (arr[j] == this.targetUserList[i].id) {
          this.target_users_modal = this.target_users_modal.concat(this.targetUserList[i].id)
        }
      }
    }
    this.modalType = 'edit'
  }
}
